import {createTheme, adaptV4Theme} from '@mui/material/styles';

const AeonikProRegular =
  "'AeonikProReqular', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
const TiemposTextRegular = "'TiemposTextRegular', Georgia, serif";

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    blue: {
      main: string;
      dark: string;
      light: string;
    };
    green: {
      main: string;
      dark: string;
      light: string;
    };
    purple: {
      main: string;
      dark: string;
      light: string;
    };
    pink: {
      main: string;
      dark: string;
      light: string;
    };
    red: {
      main: string;
      dark: string;
      light: string;
    };
    gray: {
      light: string;
      main: string;
      border: string;
      medium: string;
      text: string;
      dark: string;
    };
    kit: {
      blue: string;
      blueInk: string;
      blueTint: string;
      ink: string;
      inkSoft: string;
      slate: string;
      slate2: string;
      mist: string;
      line: string;
      amber: string;
      amberTint: string;
      green: string;
      greenTint: string;
      purple: string;
      purpleTint: string;
    };
  }
  interface PaletteOptions {
    blue: {
      main: string;
      dark: string;
      light: string;
    };
    green: {
      main: string;
      dark: string;
      light: string;
    };
    purple: {
      main: string;
      dark: string;
      light: string;
    };
    pink: {
      main: string;
      dark: string;
      light: string;
    };
    red: {
      main: string;
      dark: string;
      light: string;
    };
    gray: {
      light: string;
      main: string;
      border: string;
      medium: string;
      text: string;
      dark: string;
    };
    kit: {
      blue: string;
      blueInk: string;
      blueTint: string;
      ink: string;
      inkSoft: string;
      slate: string;
      slate2: string;
      mist: string;
      line: string;
      amber: string;
      amberTint: string;
      green: string;
      greenTint: string;
      purple: string;
      purpleTint: string;
    };
  }
}

declare module '@mui/material/styles' {
  interface Theme {
    radius: {
      sm: number;
      md: number;
      lg: number;
      xl: number;
      pill: number;
    };
  }
  interface ThemeOptions {
    radius?: {
      sm?: number;
      md?: number;
      lg?: number;
      xl?: number;
      pill?: number;
    };
  }
}

export const theme = createTheme(
  adaptV4Theme({
    palette: {
      // black
      primary: {
        main: '#000000',
        light: '#242424',
      },
      // white
      secondary: {
        main: '#FFFFFF',
      },
      blue: {
        main: '#1CA7E5',
        dark: '#0C82BD',
        light: '#EAF6FD',
      },
      green: {
        main: '#15A05B',
        dark: '#128C4F',
        light: '#DCF1DF',
      },
      purple: {
        main: '#A373E8',
        dark: '#8C50E2',
        light: '#F5F0FE',
      },
      pink: {
        main: '#FFA0F7',
        dark: '#F97BEF',
        light: '#FFEBFD',
      },
      red: {
        main: '#FF432E',
        dark: '#DA1C06',
        light: '#FFE5E4',
      },
      gray: {
        light: '#F7F7F7',
        main: '#E6E6E6',
        border: '#D9D9D9',
        medium: '#B3B3B3',
        text: '#999999',
        dark: '#717171',
      },
      kit: {
        blue: '#1CA7E5',
        blueInk: '#0C82BD',
        blueTint: '#EAF6FD',
        ink: '#13212E',
        inkSoft: '#33424E',
        slate: '#65717C',
        slate2: '#9BA6AF',
        mist: '#F3F6F8',
        line: '#E6EBEF',
        amber: '#E0972F',
        amberTint: '#FBF1DF',
        green: '#16A77A',
        greenTint: '#E6F6F0',
        purple: '#A373E8',
        purpleTint: '#F0EDFE',
      },
    },

    typography: {
      fontFamily: AeonikProRegular,

      h1: {
        fontFamily: TiemposTextRegular,
      },
      h2: {
        fontFamily: TiemposTextRegular,
      },
      h3: {
        fontFamily: TiemposTextRegular,
      },
      h4: {
        fontFamily: TiemposTextRegular,
      },
      h5: {
        fontFamily: TiemposTextRegular,
      },
      h6: {
        fontFamily: TiemposTextRegular,
      },
      body1: {
        fontFamily: AeonikProRegular,
      },
      body2: {
        fontFamily: AeonikProRegular,
      },
      button: {
        fontFamily: AeonikProRegular,
      },
      caption: {
        fontFamily: AeonikProRegular,
      },
      overline: {
        fontFamily: AeonikProRegular,
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 601,
        md: 1024,
        lg: 1440,
        xl: 1920,
      },
    },
    overrides: {
      MuiPaper: {
        rounded: {
          borderRadius: 12,
        },
        elevation1: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        },
      },
      MuiCard: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        },
      },
      MuiButton: {
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
          },
        },
      },
    },
  }),
  {
    radius: {
      sm: 10,
      md: 12,
      lg: 16,
      xl: 20,
      pill: 999,
    },
  },
);
